<template>
  <section class="section">
    <div class="section__title">
      <slot name="title"/>
    </div>
    <div class="section__wrapper">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ContactsSection',
};
</script>

<style scoped lang="scss">
.section {
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 1rem 1rem 1.6rem;
  background: color(default);
  border-radius: 0.5rem;
  box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;

  @include desktop {
    padding: 2rem;
  }

  &__title {
    margin-bottom: 2rem;

    @include desktop {
      margin-bottom: 3rem;
    }
  }

  &__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, auto);
    grid-gap: 2rem;

    @include desktop {
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: 1fr;
    }
  }
}
</style>
